// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"ea21f8a0","165":"ab3fc1cd","406":"35c6c999","768":"4c97fe95","772":"5342e65e","880":"1f408959"}[chunkId] + ".chunk.js";
};